import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAllBenefits,
  fetchBcaReport,
  fetchExpenseCategories,
  fetchExpenseRequests,
  fetchFitnessCenters,
  fetchGymBenefits,
  fetchGymFeedbacks,
  fetchHygieneCategory,
  fetchHygieneCommandCenterGymCompliance,
  fetchHygieneCommandCenterMatrix,
  fetchHygieneCommandCenterStats,
  fetchHygieneTaskFrequency,
  fetchHygieneTasks,
  fetchHygineAddonRequests,
  fetchHygineFrequencies,
  fetchHygineFrequenciesTasks,
  fetchHygineGymwise,
  fetchHygineRequests,
  fetchHygineStats,
  fetchHygineTaskCategory,
  fetchHygineTasksApproval,
  fetchHygineTasksLogs,
  fetchHygineTasksLogsStatus,
  fetchHygineTasksLogsV2,
  fetchProcessManager,
  fetchTaskDetails,
  fetchTimeSheet,
} from "./hygieneAPI";

export const fetchHygieneCategoryData = createAsyncThunk(
  "hygiene/fetchHygieneCategoryData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygieneCategory(filters, token);
    return response;
  }
);

export const fetchHygieneTaskFrequencyData = createAsyncThunk(
  "hygiene/fetchHygieneTaskFrequencyData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygieneTaskFrequency(filters, token);
    return response;
  }
);

export const fetchHygieneTasksData = createAsyncThunk(
  "hygiene/fetchHygieneTasksData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygieneTasks(filters, token);
    return response;
  }
);

export const fetchExpenseCategoriesData = createAsyncThunk(
  "hygiene/fetchExpenseCategoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchExpenseCategories(filters, token);
    return response;
  }
);

export const fetchProcessManagerData = createAsyncThunk(
  "hygiene/fetchProcessManagerData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchProcessManager(filters, token);
    return response;
  }
);

export const fetchExpenseRequestsData = createAsyncThunk(
  "hygiene/fetchExpenseRequestsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchExpenseRequests(filters, token);
    return response;
  }
);

export const fetchFitnessCentersData = createAsyncThunk(
  "hygiene/fetchFitnessCentersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchFitnessCenters(filters, token);
    return response;
  }
);

export const fetchGymBenefitsData = createAsyncThunk(
  "hygiene/fetchGymBenefitsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymBenefits(filters, token);
    return response;
  }
);

export const fetchAllBenefitsData = createAsyncThunk(
  "hygiene/fetchAllBenefitsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllBenefits(filters, token);
    return response;
  }
);

export const fetchTimeSheetData = createAsyncThunk(
  "hygiene/fetchTimeSheetData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTimeSheet(filters, token);
    return response;
  }
);

export const fetchHygineTasksLogsData = createAsyncThunk(
  "hygiene/fetchHygineTasksLogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineTasksLogs(filters, token);
    return response;
  }
);

export const fetchHygineTasksLogsDataV2 = createAsyncThunk(
  "hygiene/fetchHygineTasksLogsDataV2",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineTasksLogsV2(filters, token);
    return response;
  }
);

export const fetchHygineTasksLogsStatusData = createAsyncThunk(
  "hygiene/fetchHygineTasksLogsStatusData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineTasksLogsStatus(filters, token);
    return response;
  }
);

export const fetchHygineTaskCategoryData = createAsyncThunk(
  "hygiene/fetchHygineTaskCategoryData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineTaskCategory(filters, token);
    return response;
  }
);

export const fetchHygineRequestsData = createAsyncThunk(
  "hygiene/fetchHygineRequestsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineRequests(filters, token);
    return response;
  }
);

export const fetchHygineAddonRequestsData = createAsyncThunk(
  "hygiene/fetchHygineAddonRequestsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineAddonRequests(filters, token);
    return response;
  }
);

export const fetchHygineGymwiseData = createAsyncThunk(
  "hygiene/fetchHygineGymwiseData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineGymwise(filters, token);
    return response;
  }
);

export const fetchHygineTasksApprovalData = createAsyncThunk(
  "hygiene/fetchHygineTasksApprovalData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineTasksApproval(filters, token);
    return response;
  }
);

export const fetchHygineStatsData = createAsyncThunk(
  "hygiene/fetchHygineStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineStats(filters, token);
    return response;
  }
);

export const fetchHygineFrequenciesData = createAsyncThunk(
  "hygiene/fetchHygineFrequenciesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineFrequencies(filters, token);
    return response;
  }
);

export const fetchHygineFrequenciesTasksData = createAsyncThunk(
  "hygiene/fetchHygineFrequenciesTasksData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygineFrequenciesTasks(filters, token);
    return response;
  }
);

export const fetchGymFeedbacksData = createAsyncThunk(
  "hygiene/fetchGymFeedbacksData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymFeedbacks(filters, token);
    return response;
  }
);

export const fetchBcaReportData = createAsyncThunk(
  "hygiene/fetchBcaReportData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBcaReport(filters, token);
    return response;
  }
);

export const fetchHygieneCommandCenterStatsData = createAsyncThunk(
  "hygiene/fetchHygieneCommandCenterStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygieneCommandCenterStats(filters, token);
    return response;
  }
);

export const fetchHygieneCommandCenterMatrixData = createAsyncThunk(
  "hygiene/fetchHygieneCommandCenterMatrixData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygieneCommandCenterMatrix(filters, token);
    return response;
  }
);

export const fetchHygieneCommandCenterGymComplianceData = createAsyncThunk(
  "hygiene/fetchHygieneCommandCenterGymComplianceData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHygieneCommandCenterGymCompliance(filters, token);
    return response;
  }
);

export const fetchTaskDetailsData = createAsyncThunk(
  "hygiene/fetchTaskDetailsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTaskDetails(filters, token);
    return response;
  }
);

const hygieneSlice = createSlice({
  name: "hygiene",
  initialState: {
    hygieneCategories: null,
    hygieneCategoriesLoading: false,

    hygieneTasks: null,
    hygieneTasksLoading: false,
    hygieneTasksError: null,

    loading: false,
    statsLoading: false,

    hygineTaskFrequency: null,
    hygineTaskFrequencyLoading: false,
    hygineTaskFrequencyError: null,

    expenseCategories: null,
    expenseCategoriesLoading: false,
    processManagerData: null,

    expenseRequests: null,
    expenseRequestsLoading: false,
    error: "",

    fitnessCenters: null,
    fitnessCentersLoading: false,
    fitnessCentersError: null,

    gymBenefits: null,
    gymBenefitsLoading: false,
    gymBenefitError: null,

    allBenefits: null,
    allBenefitsLoading: false,
    allBenefitsError: null,

    hygineTaskLogs: null,
    hygineTaskLogsLoading: false,
    hygineTaskLogsError: null,

    hygineTaskLogsV2: null,
    hygineTaskLogsLoadingV2: false,
    hygineTaskLogsErrorV2: null,

    hygineTaskCategory: null,
    hygineTaskCategoryLoading: false,
    hygineTaskCategoryError: null,

    hygineRequests: null,
    hygineRequestsLoading: false,
    hygineRequestsError: null,

    hygineAddonRequests: null,
    hygineAddonRequestsLoading: false,
    hygineAddonRequestsError: null,

    hygineGymwiseData: null,
    hygineGymwiseDataLoading: false,
    hygineGymwiseDataError: null,

    hygineTaskApproval: null,
    hygineTaskApprovalLoading: false,
    hygineTaskApprovalError: null,

    hygineTaskDetails: null,
    hygineTaskDetailsLoading: false,
    hygineTaskDetailsError: null,

    hygineStats: null,
    hygineStatsLoading: false,
    hygineStatsError: null,

    hygineFrequencies: null,
    hygineFrequenciesLoading: false,
    hygineFrequenciesError: null,

    hygineFrequencyTasks: null,
    hygineFrequencyTasksLoading: false,
    hygineFrequencyTasksError: null,

    gymFeedbacks: null,
    gymFeedbacksLoading: false,
    gymFeedbacksError: null,

    bcaReport: null,
    bcaReportLoading: false,
    bcaReportError: null,

    hygieneCommandCenterStats: null,
    hygieneCommandCenterStatsLoading: false,
    hygieneCommandCenterStatsError: null,

    hygieneCommandCenterMatrix: null,
    hygieneCommandCenterMatrixLoading: false,
    hygieneCommandCenterMatrixError: null,

    hygieneCommandCenterGymCompliance: null,
    hygieneCommandCenterGymComplianceLoading: false,
    hygieneCommandCenterGymComplianceError: null,

    taskDetails: null,
    taskDetailsLoading: false,
    taskDetailsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHygieneCategoryData.pending, (state) => {
        state.hygieneCategoriesLoading = true;
      })
      .addCase(fetchHygieneCategoryData.fulfilled, (state, action) => {
        state.hygieneCategoriesLoading = false;
        state.hygieneCategories = action.payload;
      })
      .addCase(fetchHygieneCategoryData.rejected, (state, action) => {
        state.hygieneCategoriesLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchHygieneTasksData.pending, (state) => {
        state.hygieneTasksLoading = true;
      })
      .addCase(fetchHygieneTasksData.fulfilled, (state, action) => {
        state.hygieneTasksLoading = false;
        state.hygieneTasks = action.payload;
      })
      .addCase(fetchHygieneTasksData.rejected, (state, action) => {
        state.hygieneTasksLoading = false;
        state.hygieneTasksError = action.error.message;
      })

      .addCase(fetchExpenseCategoriesData.pending, (state) => {
        state.expenseCategoriesLoading = true;
      })
      .addCase(fetchExpenseCategoriesData.fulfilled, (state, action) => {
        state.expenseCategoriesLoading = false;
        state.expenseCategories = action.payload;
      })
      .addCase(fetchExpenseCategoriesData.rejected, (state, action) => {
        state.expenseCategoriesLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchProcessManagerData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProcessManagerData.fulfilled, (state, action) => {
        state.loading = false;
        state.processManagerData = action.payload;
      })
      .addCase(fetchProcessManagerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchExpenseRequestsData.pending, (state) => {
        state.expenseRequestsLoading = true;
      })
      .addCase(fetchExpenseRequestsData.fulfilled, (state, action) => {
        state.expenseRequestsLoading = false;
        state.expenseRequests = action.payload;
      })
      .addCase(fetchExpenseRequestsData.rejected, (state, action) => {
        state.expenseRequestsLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchFitnessCentersData.pending, (state) => {
        state.fitnessCentersLoading = true;
      })
      .addCase(fetchFitnessCentersData.fulfilled, (state, action) => {
        state.fitnessCentersLoading = false;
        state.fitnessCenters = action.payload;
      })
      .addCase(fetchFitnessCentersData.rejected, (state, action) => {
        state.fitnessCentersLoading = false;
        state.fitnessCentersError = action.error.message;
      })

      .addCase(fetchGymBenefitsData.pending, (state) => {
        state.gymBenefitsLoading = true;
      })
      .addCase(fetchGymBenefitsData.fulfilled, (state, action) => {
        state.gymBenefitsLoading = false;
        state.gymBenefits = action.payload;
      })
      .addCase(fetchGymBenefitsData.rejected, (state, action) => {
        state.gymBenefitsLoading = false;
        state.gymBenefitError = action.error.message;
      })

      .addCase(fetchAllBenefitsData.pending, (state) => {
        state.allBenefitsLoading = true;
      })
      .addCase(fetchAllBenefitsData.fulfilled, (state, action) => {
        state.allBenefitsLoading = false;
        state.allBenefits = action.payload;
      })
      .addCase(fetchAllBenefitsData.rejected, (state, action) => {
        state.allBenefitsLoading = false;
        state.allBenefitsError = action.error.message;
      })

      .addCase(fetchHygieneTaskFrequencyData.pending, (state) => {
        state.hygineTaskFrequencyLoading = true;
      })
      .addCase(fetchHygieneTaskFrequencyData.fulfilled, (state, action) => {
        state.hygineTaskFrequencyLoading = false;
        state.hygineTaskFrequency = action.payload;
      })
      .addCase(fetchHygieneTaskFrequencyData.rejected, (state, action) => {
        state.hygineTaskFrequencyLoading = false;
        state.hygineTaskFrequencyError = action.error.message;
      })

      .addCase(fetchHygineTasksLogsData.pending, (state) => {
        state.hygineTaskLogsLoading = true;
      })
      .addCase(fetchHygineTasksLogsData.fulfilled, (state, action) => {
        state.hygineTaskLogsLoading = false;
        state.hygineTaskLogs = action.payload;
      })
      .addCase(fetchHygineTasksLogsData.rejected, (state, action) => {
        state.hygineTaskLogsLoading = false;
        state.hygineTaskLogsError = action.error.message;
      })

      .addCase(fetchHygineTasksLogsDataV2.pending, (state) => {
        state.hygineTaskLogsLoadingV2 = true;
      })
      .addCase(fetchHygineTasksLogsDataV2.fulfilled, (state, action) => {
        state.hygineTaskLogsLoadingV2 = false;
        state.hygineTaskLogsV2 = action.payload;
      })
      .addCase(fetchHygineTasksLogsDataV2.rejected, (state, action) => {
        state.hygineTaskLogsLoadingV2 = false;
        state.hygineTaskLogsErrorV2 = action.error.message;
      })

      .addCase(fetchHygineTaskCategoryData.pending, (state) => {
        state.hygineTaskCategoryLoading = true;
      })
      .addCase(fetchHygineTaskCategoryData.fulfilled, (state, action) => {
        state.hygineTaskCategoryLoading = false;
        state.hygineTaskCategory = action.payload;
      })
      .addCase(fetchHygineTaskCategoryData.rejected, (state, action) => {
        state.hygineTaskCategoryLoading = false;
        state.hygineTaskCategoryError = action.error.message;
      })

      .addCase(fetchHygineRequestsData.pending, (state) => {
        state.hygineRequestsLoading = true;
      })
      .addCase(fetchHygineRequestsData.fulfilled, (state, action) => {
        state.hygineRequestsLoading = false;
        state.hygineRequests = action.payload;
      })
      .addCase(fetchHygineRequestsData.rejected, (state, action) => {
        state.hygineRequestsLoading = false;
        state.hygineRequestsError = action.error.message;
      })

      .addCase(fetchHygineAddonRequestsData.pending, (state) => {
        state.hygineAddonRequestsLoading = true;
      })
      .addCase(fetchHygineAddonRequestsData.fulfilled, (state, action) => {
        state.hygineAddonRequestsLoading = false;
        state.hygineAddonRequests = action.payload;
      })
      .addCase(fetchHygineAddonRequestsData.rejected, (state, action) => {
        state.hygineAddonRequestsLoading = false;
        state.hygineAddonRequestsError = action.error.message;
      })

      .addCase(fetchHygineGymwiseData.pending, (state) => {
        state.hygineGymwiseDataLoading = true;
      })
      .addCase(fetchHygineGymwiseData.fulfilled, (state, action) => {
        state.hygineGymwiseDataLoading = false;
        state.hygineGymwiseData = action.payload;
      })
      .addCase(fetchHygineGymwiseData.rejected, (state, action) => {
        state.hygineGymwiseDataLoading = false;
        state.hygineGymwiseDataError = action.error.message;
      })

      .addCase(fetchHygineTasksApprovalData.pending, (state) => {
        state.hygineTaskApprovalLoading = true;
      })
      .addCase(fetchHygineTasksApprovalData.fulfilled, (state, action) => {
        state.hygineTaskApprovalLoading = false;
        state.hygineTaskApproval = action.payload;
      })
      .addCase(fetchHygineTasksApprovalData.rejected, (state, action) => {
        state.hygineTaskApprovalLoading = false;
        state.hygineTaskApprovalError = action.error.message;
      })

      .addCase(fetchHygineTasksLogsStatusData.pending, (state) => {
        state.hygineTaskDetailsLoading = true;
      })
      .addCase(fetchHygineTasksLogsStatusData.fulfilled, (state, action) => {
        state.hygineTaskDetailsLoading = false;
        state.hygineTaskDetails = action.payload;
      })
      .addCase(fetchHygineTasksLogsStatusData.rejected, (state, action) => {
        state.hygineTaskDetailsLoading = false;
        state.hygineTaskDetailsError = action.error.message;
      })

      .addCase(fetchHygineStatsData.pending, (state) => {
        state.hygineStatsLoading = true;
        state.hygineStatsError = null;
      })
      .addCase(fetchHygineStatsData.fulfilled, (state, action) => {
        state.hygineStatsLoading = false;
        state.hygineStatsError = null;
        state.hygineStats = action.payload;
      })
      .addCase(fetchHygineStatsData.rejected, (state, action) => {
        state.hygineStatsLoading = false;
        state.hygineStatsError = action.error.message;
      })

      .addCase(fetchHygineFrequenciesData.pending, (state) => {
        state.hygineFrequenciesLoading = true;
        state.hygineFrequenciesError = null;
      })
      .addCase(fetchHygineFrequenciesData.fulfilled, (state, action) => {
        state.hygineFrequenciesLoading = false;
        state.hygineFrequenciesError = null;
        state.hygineFrequencies = action.payload;
      })
      .addCase(fetchHygineFrequenciesData.rejected, (state, action) => {
        state.hygineFrequenciesLoading = false;
        state.hygineFrequenciesError = action.error.message;
      })

      .addCase(fetchHygineFrequenciesTasksData.pending, (state) => {
        state.hygineFrequencyTasksLoading = true;
      })
      .addCase(fetchHygineFrequenciesTasksData.fulfilled, (state, action) => {
        state.hygineFrequencyTasksLoading = false;
        state.hygineFrequencyTasks = action.payload;
      })
      .addCase(fetchHygineFrequenciesTasksData.rejected, (state, action) => {
        state.hygineFrequencyTasksLoading = false;
        state.hygineFrequencyTasksError = action.error.message;
      })

      .addCase(fetchGymFeedbacksData.pending, (state) => {
        state.gymFeedbacksLoading = true;
      })
      .addCase(fetchGymFeedbacksData.fulfilled, (state, action) => {
        state.gymFeedbacksLoading = false;
        state.gymFeedbacks = action.payload;
      })
      .addCase(fetchGymFeedbacksData.rejected, (state, action) => {
        state.gymFeedbacksLoading = false;
        state.gymFeedbacksError = action.error.message;
      })

      .addCase(fetchBcaReportData.pending, (state) => {
        state.bcaReportLoading = true;
      })
      .addCase(fetchBcaReportData.fulfilled, (state, action) => {
        state.bcaReportLoading = false;
        state.bcaReport = action.payload;
      })
      .addCase(fetchBcaReportData.rejected, (state, action) => {
        state.bcaReportLoading = false;
        state.bcaReportError = action.error.message;
      })

      .addCase(fetchHygieneCommandCenterStatsData.pending, (state) => {
        state.hygieneCommandCenterStatsLoading = true;
        state.hygieneCommandCenterStatsError = null;
      })
      .addCase(fetchHygieneCommandCenterStatsData.fulfilled, (state, action) => {
        state.hygieneCommandCenterStatsLoading = false;
        state.hygieneCommandCenterStatsError = null;
        state.hygieneCommandCenterStats = action.payload;
      })
      .addCase(fetchHygieneCommandCenterStatsData.rejected, (state, action) => {
        state.hygieneCommandCenterStatsLoading = false;
        state.hygieneCommandCenterStatsError = action.error.message;
      })

      .addCase(fetchHygieneCommandCenterMatrixData.pending, (state) => {
        state.hygieneCommandCenterMatrixLoading = true;
        state.hygieneCommandCenterMatrixError = null;
      })
      .addCase(fetchHygieneCommandCenterMatrixData.fulfilled, (state, action) => {
        state.hygieneCommandCenterMatrixLoading = false;
        state.hygieneCommandCenterMatrixError = null;
        state.hygieneCommandCenterMatrix = action.payload;
      })
      .addCase(fetchHygieneCommandCenterMatrixData.rejected, (state, action) => {
        state.hygieneCommandCenterMatrixLoading = false;
        state.hygieneCommandCenterMatrixError = action.error.message;
      })

      .addCase(fetchHygieneCommandCenterGymComplianceData.pending, (state) => {
        state.hygieneCommandCenterGymComplianceLoading = true;
        state.hygieneCommandCenterGymComplianceError = null;
      })
      .addCase(fetchHygieneCommandCenterGymComplianceData.fulfilled, (state, action) => {
        state.hygieneCommandCenterGymComplianceLoading = false;
        state.hygieneCommandCenterGymComplianceError = null;
        state.hygieneCommandCenterGymCompliance = action.payload;
      })
      .addCase(fetchHygieneCommandCenterGymComplianceData.rejected, (state, action) => {
        state.hygieneCommandCenterGymComplianceLoading = false;
        state.hygieneCommandCenterGymComplianceError = action.error.message;
      })

      .addCase(fetchTaskDetailsData.pending, (state) => {
        state.taskDetailsLoading = true;
        state.taskDetailsError = null;
      })
      .addCase(fetchTaskDetailsData.fulfilled, (state, action) => {
        state.taskDetailsLoading = false;
        state.taskDetailsError = null;
        state.taskDetails = action.payload;
      })
      .addCase(fetchTaskDetailsData.rejected, (state, action) => {
        state.taskDetailsLoading = false;
        state.taskDetailsError = action.error.message;
      });
  },
});

export default hygieneSlice.reducer;
